import request from "@/utils/request";

export default function list() {
    return request({
        url: `/areaDetail/agency/list`,
        method: 'get',
    })
}
